import { render, staticRenderFns } from "./ReitsSingle.vue?vue&type=template&id=1f0a8319&scoped=true"
import script from "./ReitsSingle.vue?vue&type=script&lang=js"
export * from "./ReitsSingle.vue?vue&type=script&lang=js"
import style0 from "./ReitsSingle.vue?vue&type=style&index=0&id=1f0a8319&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a8319",
  null
  
)

export default component.exports